import React, { useState } from "react";
import styles from "./ExportContentModal.module.css";
import clsx from "clsx";
import { ExportCategoryAPi } from "../../../../../../api/KnowledgeApiCall";

interface ExportContentModalProps {
  isOpen?: boolean;
  onClose?: () => void;
}

const ExportContentModal: React.FC<ExportContentModalProps> = ({
  isOpen = false,
  onClose,
}) => {
  if (!isOpen) return null;
  const [category, setCategory] = useState("");
  const categoryOptions = [
    { value: "image", name: "Image" },
    { value: "knowledge", name: "Knowledge" },
    { value: "knowledgecontent", name: "Knowledge Content" },
    { value: "knowledgecontentimage", name: "Knowledge Content Image" },
    { value: "nodeprompt", name: "Node Prompt" },
    { value: "sop", name: "SOP" },
    { value: "intent", name: "Intent" },
  ];
  const handleOnClose = () => {
    onClose?.();
    setCategory("");
    setError("");
  };
  const [error, setError] = useState("");

  const handleOnCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setCategory(selectedValue);
    setError("");
  };

  const handleExport = async () => {
    if (category != "") await ExportCategoryAPi(category);
    else {
      setError("Please Select Knowledge Category");
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div
            style={{
              flex: 1,
              flexDirection: "row",
              display: "flex",
              gap: "16px",
            }}
          ></div>
          <button className={styles.closeButton} onClick={handleOnClose}>
            ×
          </button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.form}>
            <p>
              <strong>Export Category: </strong>
            </p>
            <div className={styles.field}>
              <select
                className={styles["category-select"]}
                value={category}
                onChange={handleOnCategoryChange}
              >
                <option value="">Select a category</option>
                {categoryOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {error && <div className={styles.error}>{error}</div>}
        </div>
        <div className={styles.modalFooter}>
          <button
            className={clsx(styles.button, styles.warning)}
            onClick={handleOnClose}
          >
            Cancel
          </button>
          <button
            className={clsx(styles.button, styles.primary)}
            onClick={handleExport}
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportContentModal;
